import React, { SyntheticEvent, ReactNode } from 'react';

import { Checkbox } from '@trqk/components';
import { constants } from '@trqk/utils';

import { getFlagForBuildEnvironment } from '../../../../featureFlags';

interface FeatureFlagSettingProps {
    constantKey?: string;
    description: ReactNode;
    enabled: boolean;
    setFeatureFlag(flagName: string, nextEnabled: boolean): void;
    flagName: FeatureFlagName;
}

export const FeatureFlagSetting = ({
    constantKey,
    description,
    enabled,
    setFeatureFlag,
    flagName,
}: FeatureFlagSettingProps): JSX.Element => {
    const developmentDefault = getFlagForBuildEnvironment(
        flagName,
        'development',
    );
    const stagingDefault = getFlagForBuildEnvironment(flagName, 'staging');
    const productionDefault = getFlagForBuildEnvironment(
        flagName,
        'production',
    );

    return (
        <div className="mb-6">
            <Checkbox
                checked={enabled}
                onChange={(e: SyntheticEvent): void => {
                    const target = e.target as HTMLInputElement;

                    setFeatureFlag(flagName, target.checked ?? false);
                }}
                inputId={flagName}
                label={flagName}
                size="large"
                readOnly={true}
            />
            <div className="ml-8">
                <div className="font-semibold">{description}</div>
                {constantKey && (
                    <div>
                        <span className="mr-2">Value:</span>
                        <span className="font-bold">
                            {/* eslint-disable-next-line */}
                            {/* @ts-ignore */}
                            {constants?.[constantKey] ?? ''}
                        </span>
                    </div>
                )}
                Deployed setting:
                <div className="ml-2 flex">
                    <div className="flex items-center">
                        <div className="ml-4 mr-1">dev.trqk.io</div>
                        <Checkbox
                            checked={developmentDefault}
                            inputId="developmentDefault"
                            color="primary"
                            readOnly={true}
                        />
                    </div>
                    <div className="flex items-center">
                        <div className="ml-4 mr-1">staging.trqk.io</div>
                        <Checkbox
                            checked={stagingDefault}
                            inputId="stagingDefault"
                            color="primary"
                            readOnly={true}
                        />
                    </div>
                    <div className="flex items-center">
                        <div className="ml-4 mr-1">iq.trqk.io</div>
                        <Checkbox
                            checked={productionDefault}
                            inputId="productionDefault"
                            color="primary"
                            readOnly={true}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
